import { isTimeframeReady } from './content';
import { getCommonValues, getMappedLocation } from 'modules/discovery/utils/tracking';

import type { DiscoveryContentTracking, DiscoveryFilterInstagramFollowers } from 'types';

export const getUpdatedFollowersValues = (currentFilter: DiscoveryFilterInstagramFollowers): DiscoveryContentTracking => {
  const transformed = currentFilter.transformed;

  return {
    followers: {
      ...currentFilter,
      min: transformed?.min,
      max: transformed?.max
    }
  };
};

export const prepareFiltersForAnalytics = (updatedFilters: any): DiscoveryContentTracking | undefined => {
  const currentFilterName = Object.keys(updatedFilters)[0];
  const currentFilter = updatedFilters[currentFilterName];

  const standardPropsWithSelectedItems = [
    'profiles',
    'genders'
  ];

  if (standardPropsWithSelectedItems.includes(currentFilterName)) {
    return getCommonValues(currentFilter, currentFilterName);
  }

  if (currentFilterName === 'followers') {
    return getUpdatedFollowersValues(currentFilter);
  }

  if (currentFilterName === 'countries') {
    return {
      [String(currentFilterName)]: getMappedLocation(currentFilter)
    };
  }

  if (currentFilterName === 'timeframe') {
    if (isTimeframeReady(currentFilter)) {
      return {
        [String(currentFilterName)]: {
          startDate: currentFilter.startDate,
          endDate: currentFilter.endDate
        }
      };
    }

    return undefined;
  }

  return {
    [String(currentFilterName)]: currentFilter
  };
};
